import { withStyles } from '@material-ui/core';
import Tab from '@mui/material/Tab';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../../constants/colors';

export interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function projectTabsProps(index: number) {
    return {
        id: `project-tab-${index}`,
        'aria-controls': `project-tabpanel-${index}`,
    };
}

export const CustomTab = withStyles({
    root: {
        borderRadius: "10px 10px 0 0 !important",
        backgroundColor: "inherit",
        color: `${colors.black} important`,
    },
    selected: {
        backgroundColor: `${colors.themeMainColor} !important`,
        color: `${colors.white} !important`
    },
    indicator: {
        backgroundColor: '#000 !important'
    }
})(Tab);

export function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`project-tabpanel-${index}`}
            aria-labelledby={`project-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ padding: "12px 12px" }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}